module.exports = __webpack_public_path__ + "img/loginLogo.3ff4d74e.svg";